export const COMPANY_WORKS_AT_LABEL = 'Работает в:';
export const COMPANY_FEEDBACKS_LABEL = 'Отзывы';
export const COMPANY_CALLBACK_BUTTON_TEXT = 'Заказать звонок';
export const COMPANY_LOGO_ALT = 'Логотип компании';
